let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("iGFLn"), load("i2eRZ")]).then(() => parcelRequire('2QLXh'));